import React from 'react';

const SEOTools: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      aria-labelledby="SEOTools"
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="48"
      height="48"
    >
      <title id="SEOTools">SEO Wizard</title>
      <g fillRule="evenodd">
        <path
          fill="#C1D9FF"
          d="M17.5 25a3.5 3.5 0 1 1 0-7h14.441a12.883 12.883 0 0 0-2.251-4.548c-5.328-6.864-15.581-6.864-20.909 0-3.63 4.677-3.63 11.385 0 16.063 5.328 6.864 15.581 6.864 20.909 0A12.918 12.918 0 0 0 31.932 25H17.5z"
        ></path>
        <path fill="#C1D9FF" d="M42.5 25H34v-7h8.5a3.5 3.5 0 1 1 0 7"></path>
        <path
          fill="#1F77FF"
          d="M19.5 6c-4.582 0-9.164 2.02-12.297 6.057-4.27 5.5-4.27 13.392 0 18.893 3.133 4.038 7.715 6.057 12.297 6.057 4.582 0 9.164-2.02 12.297-6.057 4.27-5.501 4.27-13.392 0-18.893C28.664 8.02 24.082 6 19.5 6m0 5c3.271 0 6.314 1.503 8.348 4.122 2.87 3.697 2.87 9.065 0 12.763-2.034 2.619-5.077 4.122-8.348 4.122-3.271 0-6.314-1.503-8.348-4.122-2.87-3.698-2.87-9.066 0-12.763C13.186 12.502 16.229 11 19.5 11"
        ></path>
        <path
          fill="#1F77FF"
          d="M41.111 39.455l-10.559-10.56-3.767 3.77 10.557 10.559a2.674 2.674 0 0 0 3.77 0 2.674 2.674 0 0 0 0-3.77"
        ></path>
      </g>
    </svg>
  );

const Contact: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      aria-labelledby="Contact"
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="48"
      height="48"
    >
      <title id="Contact">Contact Manager</title>
      <g fillRule="evenodd">
        <path
          fill="#C1D9FF"
          d="M45.127 36.64a12.632 12.632 0 0 0-8.082-8.588c-.314-.106-.363-.522-.094-.718a6.82 6.82 0 0 0 2.788-4.673h.313c.719 0 1.407-.426 1.627-1.11a1.61 1.61 0 0 0-.243-1.482v-3.803c0-5.098-4.681-9.153-9.96-8.098-4.12.824-6.97 4.624-6.97 8.825v3.076c-.296.396-.424.92-.243 1.484.219.683.908 1.108 1.626 1.108h.312c.116.931.433 1.796.889 2.571h-6.18c.456-.775.773-1.64.889-2.57h.312c.718 0 1.407-.426 1.626-1.109a1.605 1.605 0 0 0-.243-1.484v-3.076c0-4.2-2.85-8-6.97-8.825-5.279-1.055-9.96 3-9.96 8.098v3.803a1.61 1.61 0 0 0-.242 1.481c.219.685.908 1.111 1.626 1.111h.313a6.82 6.82 0 0 0 2.788 4.673c.269.196.221.612-.094.718a12.634 12.634 0 0 0-8.082 8.588C2.546 37.833 3.495 39 4.732 39h38.536c1.237 0 2.186-1.167 1.859-2.36"
          data-color="1"
        ></path>
        <path
          fill="#1F77FF"
          d="M38.925 38.877A16.86 16.86 0 0 0 27.619 30.2a.38.38 0 0 1-.303-.373.39.39 0 0 1 .21-.346c2.378-1.175 4.105-3.48 4.447-6.212h.463a1.925 1.925 0 0 0 1.918-1.916c0-.428-.147-.819-.384-1.138V16.18C33.97 10.58 29.384 6 23.779 6c-5.362 0-9.75 4.38-9.75 9.736v4.478a1.9 1.9 0 0 0-.382 1.138c0 1.052.863 1.916 1.918 1.916h.463c.34 2.732 2.069 5.037 4.446 6.212a.39.39 0 0 1 .21.346.38.38 0 0 1-.303.373 16.855 16.855 0 0 0-11.306 8.68c-.737 1.42.27 3.12 1.87 3.12h26.109c1.6 0 2.608-1.7 1.87-3.122"
          data-color="2"
        ></path>
      </g>
    </svg>
  );

const Inbox: React.FunctionComponent<React.SVGAttributes<SVGElement>> = () => (
  <svg
    aria-labelledby="Inbox"
    viewBox="4.001 6 42 38.001"
    fill="currentColor"
    width="48"
    height="48"
  >
    <title id="Inbox">Contact Manager</title>
    <g fill="none" fill-rule="evenodd">
      <g>
        <g>
          <g>
            <g>
              <g>
                <g>
                  <path
                    fill="#C1D9FF"
                    d="M22.338 15.31l6.517-3.738-4.562-10.206C23.953.592 23.19.086 22.338.072H6.517c-.86-.017-1.64.499-1.955 1.294L0 11.572l5.793 3.019V18.4h7.24l2.173 1.15 1.955-1.15h5.286v-3.09h-.109z"
                    transform="translate(-891.000000, -3035.000000) translate(0.000000, 2849.000000) translate(72.000000, 186.000000) translate(819.000000, 0.000000) translate(0.000000, 0.500000) translate(10.000000, 12.000000)"
                  />
                  <path
                    fill="#1F77FF"
                    d="M21.47 11.5c-.689-.025-1.284.473-1.376 1.15-.53 2.663-2.877 4.587-5.612 4.6-2.742-.013-5.1-1.933-5.648-4.6-.134-.654-.704-1.13-1.376-1.15H.036v9.344c0 1.19.973 2.156 2.172 2.156h24.62c1.2 0 2.172-.965 2.172-2.156V11.5h-7.53zM19.37 4.313h-1.268V0h-7.24v4.313H9.557c-.324.003-.617.19-.755.48-.139.29-.099.634.103.885l4.78 5.247c.208.24.512.378.832.378.32 0 .624-.138.833-.378l4.779-5.247c.17-.27.184-.608.035-.89-.15-.282-.439-.463-.76-.476"
                    transform="translate(-891.000000, -3035.000000) translate(0.000000, 2849.000000) translate(72.000000, 186.000000) translate(819.000000, 0.000000) translate(0.000000, 0.500000) translate(10.000000, 12.000000)"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

const Workflows: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      aria-labelledby="Workflows"
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="48"
      height="48"
    >
      <title id="Workflows">Contact Manager</title>
      <g
        id="Workflows"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          transform="translate(0.000000, 0.500000)"
          fill-rule="nonzero"
          id="Group"
        >
          <g id="Group-5" transform="translate(7.000000, 11.000000)">
            <path
              d="M19,26 L2,26 C0.8954305,26 0,25.1045695 0,24 L0,17 C0,15.8954305 0.8954305,15 2,15 L19,15 C20.1045695,15 21,15.8954305 21,17 L21,24 C21,25.1045695 20.1045695,26 19,26 Z"
              id="Path-Copy"
              fill="#1F77FF"
            ></path>
            <path
              d="M31,18 L14,18 C12.8954305,18 12,17.1045695 12,16 L12,7 L31,7 C32.1045695,7 33,7.8954305 33,9 L33,16 C33,17.1045695 32.1045695,18 31,18 Z"
              id="Path-Copy-2"
              fill="#C1D9FF"
            ></path>
            <path
              d="M23,11 L6,11 C4.8954305,11 4,10.1045695 4,9 L4,2 C4,0.8954305 4.8954305,0 6,0 L23,0 C24.1045695,0 25,0.8954305 25,2 L25,9 C25,10.1045695 24.1045695,11 23,11 Z"
              id="Path-Copy-3"
              fill="#1F77FF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );

const TasksReminders: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      aria-labelledby="TasksReminders"
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="48"
      height="48"
    >
      <title id="TasksReminders">Contact Manager</title>
      <g
        id="Tasks-&amp;-Reminders"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Group"
          transform="translate(0.000000, 0.500000)"
          fill-rule="nonzero"
        >
          <g id="Group-4" transform="translate(9.000000, 9.000000)">
            <path
              d="M27.5,25 L7.5,25 C6.11928813,25 5,23.8807119 5,22.5 L5,2.5 C5,1.11928813 6.11928813,0 7.5,0 L27.5,0 C28.8807119,0 30,1.11928813 30,2.5 L30,22.5 C30,23.8807119 28.8807119,25 27.5,25 Z"
              id="Path-Copy"
              fill="#C1D9FF"
            ></path>
            <path
              d="M22.5,30 L2.5,30 C1.11928813,30 0,28.8807119 0,27.5 L0,7.5 C0,6.11928813 1.11928813,5 2.5,5 L22.5,5 C23.8807119,5 25,6.11928813 25,7.5 L25,27.5 C25,28.8807119 23.8807119,30 22.5,30 Z"
              id="Path-Copy-2"
              fill="#1F77FF"
            ></path>
            <path
              d="M11,22.0000167 C10.734197,22.0015368 10.4787188,21.8971865 10.29,21.71 L7.29,18.71 C6.89787783,18.3178778 6.89787783,17.6821222 7.29,17.29 C7.68212217,16.8978778 8.31787783,16.8978778 8.71,17.29 L11,19.59 L16.29,14.29 C16.5436586,14.0363414 16.913374,13.9372765 17.259878,14.030122 C17.6063821,14.1229674 17.8770326,14.3936179 17.969878,14.740122 C18.0627235,15.086626 17.9636586,15.4563414 17.71,15.71 L11.71,21.71 C11.5212812,21.8971865 11.265803,22.0015368 11,22.0000167 Z"
              id="Path-Copy-3"
              fill="#C1D9FF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );

const Marketing: React.FunctionComponent<React.SVGAttributes<SVGElement>> =
  () => (
    <svg
      aria-labelledby="Marketing"
      viewBox="4.001 6 42 38.001"
      fill="currentColor"
      width="48"
      height="48"
    >
      <title id="Marketing">Contact Manager</title>
      <g
        id="Integrations"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g
          id="Group"
          transform="translate(0.000000, 0.500000)"
          fill-rule="nonzero"
        >
          <g>
            <path
              d="M36.87,10 C37.4275878,9.98382581 37.9681033,10.1933767 38.369077,10.5811729 C38.725498,10.9258806 38.9448448,11.3854864 38.9909162,11.875138 L39,12.06 L39,35.94 C39,36.4915837 38.7789101,37.020151 38.3860723,37.40735 C38.0368831,37.7515269 37.5779684,37.9584473 37.0929445,37.9946925 L36.91,38.0002188 L29.05,38.0002188 L29,12.06 C29.0026458,11.5109999 29.2232759,10.9855371 29.613353,10.5992108 C29.9600882,10.2558096 30.4154596,10.0473483 30.8979529,10.0071303 L31.08,10 L36.87,10 Z M19,23 L19,38 L11.5,38 C10.1192881,38 9,36.8807119 9,35.5 L9,25.5 C9,24.1192881 10.1192881,23 11.5,23 L19,23 Z"
              id="Shape-Copy"
              fill="#1F77FF"
            ></path>
            <path
              d="M21.5,16 L29,16 L29,38 L19,38 L19,18.5 C19,17.1192881 20.1192881,16 21.5,16 Z"
              id="Path-Copy"
              fill="#C1D9FF"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );

export { SEOTools, Contact, Inbox, Workflows, TasksReminders, Marketing };
